import { Injector } from "@angular/core";
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";
import { OnDemandSimpleSearchListNode } from "../../OnDemandSimpleSearchListNode";
import { XevprmMessageEntityListView } from "../../../Data/MedicinalProductData/XevprmMessageEntityListView";
import { XevprmMessageAutoUploadEntity } from "../Entity/XevprmMessageAutoUploadEntity";
import { DateUtil } from "../../../DateUtil";


export class TreeNodeMedicinalProductsXevprmMessage extends OnDemandSimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new XevprmMessageEntityListView(items), "XEVPRM Messages", EntityEnum.xevprmMessage);
        this.useHist = useHist;
    }

    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${model.senderid} - ${DateUtil.getDateTimeFormat(model.messagedate)} - ${model.messagenumber}`;
        return this.addChildNode(XevprmMessageAutoUploadEntity,labelTemplate, this,model, this.useHist, false, false);
    }

    override getCriteriaFields(): string[] {
        return ['messagenumber','senderid'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for XEVPRM messages";
    }
    
}